export const INCREMENT_UPDATE_REQUESTS = (state) => {
  state.updatePending++
}
